import { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Tickets from './pages/Tickets'
import Locatarios from './pages/Locatarios'
import Pagos from './pages/Pagos'
import Comunicados from './pages/Comunicados'
import Cortes from './pages/Cortes'
import Solicitudes from './pages/Solicitudes'
import FormularioActualizarDatos from './pages/FormularioActualizarDatos'
import FormularioCotizacionMantenimiento from './pages/FormularioCotizacionMantenimiento'
import './styles/arboleda.css'

export default function App() {
  const [usuario, setUsuario] = useState(null)
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('token')
    const user = localStorage.getItem('usuario')
    if (token && user) setUsuario(JSON.parse(user))
    setChecking(false)
  }, [])

  if (checking) return null

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/formulario/actualizar-datos/:ticketId" element={<FormularioActualizarDatos />} />
        <Route path="/formulario/cotizacion-mantenimiento/:ticketId" element={<FormularioCotizacionMantenimiento />} />
        <Route
          path="/*"
          element={
            !usuario ? (
              <Login onLogin={setUsuario} />
            ) : (
              <Layout usuario={usuario} onLogout={() => setUsuario(null)}>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/tickets" element={<Tickets />} />
                  <Route path="/residentes" element={<Locatarios />} />
                  <Route path="/pagos" element={<Pagos />} />
                  <Route path="/comunicados" element={<Comunicados />} />
                  <Route path="/cortes" element={<Cortes />} />
                  <Route path="/solicitudes" element={<Solicitudes />} />
                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </Layout>
            )
          }
        />
      </Routes>
    </BrowserRouter>
  )
}
